import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { setDocumentTitle } from '../../utils/utils';

const TrashieContainerPublic = ({
  children,
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    setDocumentTitle();
  }, [pathname]);

  return children;
};

export default TrashieContainerPublic;
